<template>
  <div class="box">
    <div class="content">
      <div class="back" @click="$router.go(-1)">
        <img src="../../image/DevelopmentDocuments/back.png" alt="" />
        <span>{{ $t('DevelopmentDocuments.Populararticles') }}</span>
      </div>
      <div class="title">{{ article.title }}</div>
      <div class="html" v-html="article.content"></div>
    </div>
  </div>
</template>

<script>
import { articles } from '@/data/articles.js'

export default {
  name: 'DocumentDetails',
  data() {
    return {
      article: {},
    }
  },
  created() {
    this.getArticleDetails()
  },
  methods: {
    getArticleDetails() {
      const articleId = parseInt(this.$route.query.id)
      const lang = this.$i18n.locale === 'en-US' ? 'en' : 'zh'
      const foundArticle = articles.find((a) => a.id === articleId)
      if (foundArticle) {
        this.article = foundArticle[lang]
      }
    },
  },
  watch: {
    '$i18n.locale': function () {
      this.getArticleDetails()
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  background: #fbfcfd;
  min-height: 100vh;
  .content {
    width: 100%;
    padding: 31px 209px 100px;
    box-sizing: border-box;
    .back {
      display: flex;
      align-items: center;
      margin-bottom: 21px;
      cursor: pointer;
      img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
      span {
        color: #006aff;
        font-family: 'HarmonyOS Sans';
        font-size: 10px;
        font-weight: 400;
      }
    }
    .title {
      color: #24252a;
      font-family: 'HarmonyOS Sans';
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 21px;
    }
  }
}
</style>
